
export class Store
{
    storeID;
    storeName;
    regionID;
    municipalityID;
    addressLine1;
    addressLine2;
    zipCode;
    phoneNumber;
    state;
    productID;
    storeProductID;
    
}
